<template>
  <div class="d-flex flex-wrap align-center" style="gap: 10px">
    <dp-date-field v-model="von" label="Zeitraum von" style="max-width: 175px"/>
    <dp-date-field v-model="bis" label="bis" :min="von" style="max-width: 175px"/>
    <v-btn small depressed :disabled="!gueltig || !geaendert" @click="uebernehmen"><v-icon small left>mdi-calendar-refresh</v-icon>Übernehmen</v-btn>
    <span v-if="gueltig" class="text-caption grey--text text--darken-1">{{ wochen.length }} Kalenderwochen
      <template v-if="erweitert"> · erweitert auf {{ fmtDay(wochen[0].montag) }} – {{ fmtDay(wochen[wochen.length - 1].sonntag) }} (ganze Wochen)</template>
    </span>
    <span v-else class="text-caption red--text">Bitte einen gültigen Zeitraum von höchstens 53 Wochen wählen.</span>
  </div>
</template>

<script>
import {fmtDay, periodWeeks} from '@/shared/dienstplan_api'
import DpDateField from './DpDateField'

// Planning range: dates are always expanded to complete ISO weeks.
export default {
  name: 'ZeitraumWahl',
  components: {DpDateField},
  props: {
    value: {type: Object, required: true}, // {von, bis}
  },
  data () {
    return {von: this.value.von, bis: this.value.bis}
  },
  computed: {
    wochen () {
      return periodWeeks(this.von, this.bis)
    },
    gueltig () {
      return this.wochen.length > 0
    },
    erweitert () {
      return this.gueltig && (this.wochen[0].montag !== this.von || this.wochen[this.wochen.length - 1].sonntag !== this.bis)
    },
    geaendert () {
      return this.von !== this.value.von || this.bis !== this.value.bis
    },
  },
  watch: {
    value (v) {
      this.von = v.von
      this.bis = v.bis
    },
  },
  methods: {
    fmtDay,
    uebernehmen () {
      this.$emit('input', {von: this.wochen[0].montag, bis: this.wochen[this.wochen.length - 1].sonntag})
    },
  },
}
</script>
